<nav class="navbar navbar-light bg-dark">
    <div class="container">
        <a class="navbar-brand" href="#">
            <img src="./assets/images/logo.jpeg" alt="MAXMOVI LOGO" width="125" height="auto">
        </a>
    </div>
</nav>

<router-outlet></router-outlet>